import { INITIALIZE_SOCKET,WITHOUT_INIT_SOCKET } from "../constants";

const initialState = {
    initializeSocket: false,
    withoutInitSocket:false
};

const socketReducer = (state = initialState, action = null) => {
    switch (action.type) {
        case INITIALIZE_SOCKET:
            return {
                ...state,
                initializeSocket: action.payload,
            };
            case WITHOUT_INIT_SOCKET:
            return {
                ...state,
                withoutInitSocket: action.payload,
            };
        default:
            return state;
    }
};

export default socketReducer;
